
import Input from './inputs';
import Page from './page/ContractPage';
import SideMenu from './side-menu';

export default {Input, Page, SideMenu };
